function getCurrencies() {
  const endpoint = 'https://backend.heurekaprints.de/currency/list';
  const requestOptions = {
  method: "GET",
  redirect: "follow"
  };

  const response = fetch(endpoint, requestOptions);
  return response;
};

